module.exports = __webpack_public_path__ + "statics/img/ISO.87fdca98.png";